import { createContext } from 'react';

export default createContext({
  containerWidth: 1216,
})
